import apiService from "./apiService";
import AppConstants from "../appConstants";

class PushConfigService {
    getAllPushConfig(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_PUSH_CONFIG_GETALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getPushConfigDetails(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_PUSH_CONFIG_DETAIL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerPushConfig(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_PUSH_CONFIG_REGISTER, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deletePushConfig(params, form) {
        return new Promise((resolve, reject) => {
            apiService.delete(AppConstants.URL_PUSH_CONFIG_DELETE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_PUSH_CONFIG_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new PushConfigService();
